import ccFlywheelFeatureDiscovery from '@post-office/team-package--i18n--cc-flywheel-feature-discovery/i18n/da.json';
import postOfficeTemplate from '@post-office/team-package--i18n--post-office-template/i18n/da.json';
import growth from '@post-office/team-package--i18n--growth/i18n/da.json';
import testMessages from '@post-office/team-package--i18n--test-messages/i18n/da.json';

export default {
	...ccFlywheelFeatureDiscovery,
	...postOfficeTemplate,
	...growth,
	...testMessages
}
